// extracted by mini-css-extract-plugin
export default {"colorBox":"gradientColorBox_colorBox__l9Qhe"};